export const fontSize = {
  xs: "13px",
  sm: "15px",
  md: "18px",
  lg: "22px",
  xl: "28px",
};
